module.exports = __webpack_public_path__ + "img/08.4598d5e1.jpg";